import { HttpInterceptorFn, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { SessionStore } from '../../shared/stores/session.store';
import { ToastrService } from 'ngx-toastr';

/**
 * Intercepts 401 (Unauthorized) responses. Clears the current session and
 * redirects the user to the login (logout) screen.
 */
export const unauthorizedInterceptor: HttpInterceptorFn = (req, next: HttpHandlerFn) => {
  const sessionStore = inject(SessionStore);
  const router = inject(Router);
  const toastrService = inject(ToastrService);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 401) {
        sessionStore.setSession(null);
        router.navigateByUrl('/login');
        toastrService.error('Your session has expired');
      }
      return throwError(() => err);
    }),
  );
};
